/* eslint-disable */
export enum TenantFeatureKey {
  CHAT_AND_AGENDA = 'ChatAndAgendaFeature'
}
